function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#32c27f",
    d: "M 35.5,5.5 C 41.8421,5.33379 48.1754,5.50046 54.5,6C 55.2524,6.67076 55.5858,7.5041 55.5,8.5C 55.5,11.8333 55.5,15.1667 55.5,18.5C 48.8333,18.5 42.1667,18.5 35.5,18.5C 35.5,18.1667 35.5,17.8333 35.5,17.5C 35.5,13.5 35.5,9.5 35.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#20a265",
    d: "M 35.5,5.5 C 35.5,9.5 35.5,13.5 35.5,17.5C 28.8574,16.7875 22.1908,16.4542 15.5,16.5C 15.8016,13.9407 15.4682,11.6074 14.5,9.5C 14.3601,7.87623 15.0267,6.70956 16.5,6C 22.8246,5.50046 29.1579,5.33379 35.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b844c",
    d: "M 14.5,9.5 C 15.4682,11.6074 15.8016,13.9407 15.5,16.5C 22.1908,16.4542 28.8574,16.7875 35.5,17.5C 35.5,17.8333 35.5,18.1667 35.5,18.5C 35.5,22.1667 35.5,25.8333 35.5,29.5C 35.1667,29.5 34.8333,29.5 34.5,29.5C 34.5,25.8333 34.5,22.1667 34.5,18.5C 31.447,18.3185 28.447,18.1519 25.5,18C 23.7254,19.4389 21.7254,20.4389 19.5,21C 20.624,21.2492 21.624,21.7492 22.5,22.5C 22.3764,23.1067 22.0431,23.44 21.5,23.5C 21.2648,22.9033 20.7648,22.5699 20,22.5C 18.6057,23.6133 17.439,24.9466 16.5,26.5C 15.2842,23.7495 13.2842,22.5828 10.5,23C 11.7079,25.2503 13.0413,27.417 14.5,29.5C 13.1667,31.5 11.8333,33.5 10.5,35.5C 11.325,36.3857 12.325,36.719 13.5,36.5C 11.7697,37.9118 10.2697,37.5785 9,35.5C 7.02809,37.2318 4.86143,38.5652 2.5,39.5C 2.33365,31.8261 2.50031,24.1594 3,16.5C 6.72998,15.5399 10.5633,15.2065 14.5,15.5C 14.5,13.5 14.5,11.5 14.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#20a265",
    d: "M 35.5,18.5 C 42.1667,18.5 48.8333,18.5 55.5,18.5C 55.5,22.1667 55.5,25.8333 55.5,29.5C 48.8333,29.5 42.1667,29.5 35.5,29.5C 35.5,25.8333 35.5,22.1667 35.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#12753d",
    d: "M 34.5,29.5 C 33.5,29.5 32.5,29.5 31.5,29.5C 29.825,33.2951 28.825,37.4618 28.5,42C 23.6486,42.1745 18.9819,42.6745 14.5,43.5C 10.5,43.5 6.5,43.5 2.5,43.5C 2.5,42.1667 2.5,40.8333 2.5,39.5C 4.86143,38.5652 7.02809,37.2318 9,35.5C 10.2697,37.5785 11.7697,37.9118 13.5,36.5C 14.7611,30.7788 16.4278,30.4455 18.5,35.5C 19.723,36.6139 21.0563,36.7805 22.5,36C 17.8732,32.0281 17.5398,27.8614 21.5,23.5C 22.0431,23.44 22.3764,23.1067 22.5,22.5C 21.624,21.7492 20.624,21.2492 19.5,21C 21.7254,20.4389 23.7254,19.4389 25.5,18C 28.447,18.1519 31.447,18.3185 34.5,18.5C 34.5,22.1667 34.5,25.8333 34.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7f2ec",
    d: "M 21.5,23.5 C 17.5398,27.8614 17.8732,32.0281 22.5,36C 21.0563,36.7805 19.723,36.6139 18.5,35.5C 16.4278,30.4455 14.7611,30.7788 13.5,36.5C 12.325,36.719 11.325,36.3857 10.5,35.5C 11.8333,33.5 13.1667,31.5 14.5,29.5C 13.0413,27.417 11.7079,25.2503 10.5,23C 13.2842,22.5828 15.2842,23.7495 16.5,26.5C 17.439,24.9466 18.6057,23.6133 20,22.5C 20.7648,22.5699 21.2648,22.9033 21.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#175b36",
    d: "M 31.5,29.5 C 32.5,29.5 33.5,29.5 34.5,29.5C 34.8333,29.5 35.1667,29.5 35.5,29.5C 35.5,33.1667 35.5,36.8333 35.5,40.5C 42.1667,40.5 48.8333,40.5 55.5,40.5C 55.5,44.5 55.5,48.5 55.5,52.5C 41.9895,52.8289 28.6562,52.4956 15.5,51.5C 15.5,49.8333 15.5,48.1667 15.5,46.5C 20.1785,46.6658 24.8452,46.4992 29.5,46C 30,45.5 30.5,45 31,44.5C 31.4993,39.5111 31.6659,34.5111 31.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f7b41",
    d: "M 35.5,29.5 C 42.1667,29.5 48.8333,29.5 55.5,29.5C 55.5,33.1667 55.5,36.8333 55.5,40.5C 48.8333,40.5 42.1667,40.5 35.5,40.5C 35.5,36.8333 35.5,33.1667 35.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#124c2c",
    d: "M 31.5,29.5 C 31.6659,34.5111 31.4993,39.5111 31,44.5C 30.5,45 30,45.5 29.5,46C 24.8452,46.4992 20.1785,46.6658 15.5,46.5C 15.5,48.1667 15.5,49.8333 15.5,51.5C 15.1667,51.5 14.8333,51.5 14.5,51.5C 14.5,48.8333 14.5,46.1667 14.5,43.5C 18.9819,42.6745 23.6486,42.1745 28.5,42C 28.825,37.4618 29.825,33.2951 31.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.054
    },
    fill: "#041009",
    d: "M 55.5,8.5 C 56.6611,23.3277 56.8277,38.3277 56,53.5C 55.5,54 55,54.5 54.5,55C 41.8333,55.6667 29.1667,55.6667 16.5,55C 15.0267,54.2904 14.3601,53.1238 14.5,51.5C 14.8333,51.5 15.1667,51.5 15.5,51.5C 28.6562,52.4956 41.9895,52.8289 55.5,52.5C 55.5,48.5 55.5,44.5 55.5,40.5C 55.5,36.8333 55.5,33.1667 55.5,29.5C 55.5,25.8333 55.5,22.1667 55.5,18.5C 55.5,15.1667 55.5,11.8333 55.5,8.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel1);
export default __webpack_public_path__ + "static/media/excel1.1b87f0d49687a278369b9998259de497.svg";
export { ForwardRef as ReactComponent };